import {createFileRoute} from '@tanstack/react-router';

import {LearningModulePage} from '@/modules/learning/pages/LearningModulePage';

/** `video` is the video open in the player; without it, the first not yet watched. */
export interface LearningModuleSearch {
  video?: string;
}

const validateSearch = (search: Record<string, unknown>): LearningModuleSearch => ({
  video: typeof search.video === 'string' ? search.video : undefined,
});

export const Route = createFileRoute('/_authenticated/learning/$moduleId')({
  validateSearch,
  component: LearningModulePage,
});
